module.exports = __webpack_public_path__ + "img/fish-2.fbe3dcdf.jpg";